export default {
  serverBaseUrl: "https://backend.suryactfbmw.in",
  api: {
    auth: {
      login: "/Auth/Login",
      refresh: "/Auth/Refresh/refreshToken",
    },
  },
};
